export default {"src":"/_next/static/media/LocationBlue.607b8229.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};